import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, take, tap } from 'rxjs/operators';
import { UserService } from '../../user/user.service';

@Injectable({ providedIn: 'root' })
export class UserSettingsResolverService {
  constructor(private userSettings: UserService) { }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
    return this.userSettings.getUserSettings().pipe(
      take(1), // Ensure the observable completes after first emission
      tap(result => {
        console.log('Resolver - User settings resolved:', result ? 'Success' : 'Null', result);
      }),
      catchError(error => {
        console.error('Resolver - Error loading user settings:', error);
        return of(null);
      })
    );
  }
}